import { render, staticRenderFns } from "./switchItem.vue?vue&type=template&id=1a74c1d8&scoped=true"
import script from "./switchItem.vue?vue&type=script&lang=js"
export * from "./switchItem.vue?vue&type=script&lang=js"
import style0 from "./switchItem.vue?vue&type=style&index=0&id=1a74c1d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a74c1d8",
  null
  
)

export default component.exports